import { defineMessages } from "react-intl";

import { node as cmv } from "src/modules/htx/forms/microbiological-procedures/cmv";
import { node as ebvSerology } from "src/modules/htx/forms/microbiological-procedures/ebvSerology";
import { node as hbvStatus } from "src/modules/htx/forms/microbiological-procedures/hbvStatus";
import { node as hcv } from "src/modules/htx/forms/microbiological-procedures/hcv";
import { node as hiv } from "src/modules/htx/forms/microbiological-procedures/hiv";
import { node as hsv1Serology } from "src/modules/htx/forms/microbiological-procedures/hsv1Serology";
import { node as hsv2Serology } from "src/modules/htx/forms/microbiological-procedures/hsv2Serology";
import { node as toxoplasmaSerology } from "src/modules/htx/forms/microbiological-procedures/toxoplasmaSerology";
import { node as treponemaPallidum } from "src/modules/htx/forms/microbiological-procedures/treponemaPallidum";
import { node as varicellaSerology } from "src/modules/htx/forms/microbiological-procedures/varicellaSerology";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.microbiological_procedures",
		defaultMessage: "Mikrobiológiai vizsgálatok"
	}
});

export const node: ParentNode = {
	id: "microbiologicalProcedures",
	value: { type: "wizard", title: messages.title },
	children: [
		cmv,
		ebvSerology,
		toxoplasmaSerology,
		varicellaSerology,
		hsv1Serology,
		hsv2Serology,
		hiv,
		treponemaPallidum,
		hbvStatus,
		hcv
	]
};
